import { render, staticRenderFns } from "./BusinessRxItemDeleteConfirmationModal.vue?vue&type=template&id=64f96a04"
import script from "./BusinessRxItemDeleteConfirmationModal.vue?vue&type=script&lang=js"
export * from "./BusinessRxItemDeleteConfirmationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports